import { useState } from "react";
import { useNavigate } from "react-router-dom";

import API from "../api/api";
import { setToken } from "../utils/auth";
import "./Login.css";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async () => {
    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await API.post("/auth/login", {
        email,
        password,
      });

      const token = res.data.token;
      setToken(token);
      navigate("/dashboard");

    } catch (err) {
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src="/images/MKS-LOGO.png" alt="MKS Logo" className="login-logo" />
        <h2>MKS Admin</h2>
        <p>Monitor and manage your community dashboard.</p>

        {error && <div className="error-message">{error}</div>}

        <div className="input-group">
          <label>Email Address</label>
          <input
            type="email"
            placeholder="admin@kannada.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && login()}
          />
        </div>

        <div className="input-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && login()}
          />
        </div>

        <button
          className="login-button"
          onClick={login}
          disabled={loading}
        >
          {loading ? <span className="loader"></span> : "Login to Dashboard"}
        </button>
      </div>
    </div>
  );
}

export default Login;